import { createStyles, getSize, rem } from '@mantine/styles';
var useStyles = createStyles(function (theme, _params, _ref) {
  var size = _ref.size;
  return {
    description: {
      wordBreak: "break-word",
      color: theme.colorScheme === "dark" ? theme.colors.dark[2] : theme.colors.gray[6],
      fontSize: "calc(".concat(getSize({
        size: size,
        sizes: theme.fontSizes
      }), " - ").concat(rem(2), ")"),
      lineHeight: 1.2,
      display: "block"
    }
  };
});
export default useStyles;